import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { deviceProductsPerRow, BREAKPOINTS } from '@utils/constants';
import {
  useDevice,
} from '@modules/discovery/composables';
import { ComputedRef } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars
import useAltGridView from './useAltGridView';

/**
 *
 * @returns {ComputedRef<number>}
 */
export function useNoOfProductsPerRow() {
  const { altGridViewEnabled, currNumberOfProducts } = useAltGridView();
  if (altGridViewEnabled.value) {
    return computed(() => currNumberOfProducts.value);
  }
  const {
    isTablet, deviceType,
  } = useDevice();
  const { width } = useWindowSize();

  const defaultNoOfProdsPerRow = deviceProductsPerRow[deviceType];
  const fitsTabletWidth = computed(() => (width.value >= BREAKPOINTS.TABLET.min) && (width.value <= BREAKPOINTS.TABLET.max));

  const isTabletInLandscape = computed(() => isTablet && !fitsTabletWidth.value);
  const noOfProdsPerRow = computed(() => (isTabletInLandscape.value ? 4 : defaultNoOfProdsPerRow));

  return noOfProdsPerRow;
}

export default useNoOfProductsPerRow;
